import type { ReactNode } from "react";
import { View, type StyleProp, type ViewStyle } from "react-native";

/**
 * On web the browser moves the page for the keyboard itself, and
 * react-native-keyboard-controller is an empty module (Metro's native-only
 * list): the sheet's button stays where it is and nothing follows the
 * keyboard. Same names as `sheetKeyboard.tsx`.
 */
export function KeyboardStickyView({
  style,
  children,
}: {
  enabled?: boolean;
  offset?: { closed?: number; opened?: number };
  style?: StyleProp<ViewStyle>;
  children?: ReactNode;
}) {
  return <View style={style}>{children}</View>;
}

export function useKeyboardHandler(
  _handlers: Record<string, unknown>,
  _deps?: unknown[],
): void {}
